import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getCanopiesData(context) {
            const response = await Vue.axios.get(`${URL_API}canopy`);
            let data = response["data"];
            context.commit("updateCanopiesData", data);
        },
        async createCanopyData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}canopy/store`, body, config);
            context.dispatch("getCanopiesData");
        },
        async pushCanopyData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}canopy/update`, body, config);
            context.dispatch("getCanopiesData");
        },
        async destroyCanopyData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}canopy/destroy`, body, config);
            context.dispatch("getCanopiesData");
        }
    },
    mutations: {
        updateCanopiesData(state, canopiesData) {
            state.canopiesData = canopiesData;
        }
    },
    state: {
        canopiesData: []
    },
    getters: {
        allCanopiesData(state) {
            return state.canopiesData;
        }
    }
};
